import { render, staticRenderFns } from "./OrgStaffFileReview.vue?vue&type=template&id=259f79dc&scoped=true&"
import script from "./OrgStaffFileReview.vue?vue&type=script&lang=js&"
export * from "./OrgStaffFileReview.vue?vue&type=script&lang=js&"
import style0 from "./OrgStaffFileReview.vue?vue&type=style&index=0&id=259f79dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f79dc",
  null
  
)

export default component.exports